// Compress an image File to a JPEG data URL, downscaled to fit within maxDim
// while preserving aspect ratio. Returns Promise<string>.
export function compressImage(file, { maxDim = 1200, quality = 0.82 } = {}) {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onerror = () => reject(reader.error);
        reader.onload = () => {
            const img = new Image();
            img.onerror = () => reject(new Error("Image load failed"));
            img.onload = () => {
                let { width, height } = img;
                const ratio = Math.min(1, maxDim / Math.max(width, height));
                width = Math.round(width * ratio);
                height = Math.round(height * ratio);

                const canvas = document.createElement("canvas");
                canvas.width = width;
                canvas.height = height;
                const ctx = canvas.getContext("2d");
                ctx.imageSmoothingEnabled = true;
                ctx.imageSmoothingQuality = "high";
                ctx.drawImage(img, 0, 0, width, height);

                // Detect alpha (PNGs with transparency) → keep PNG, else JPEG
                const mime =
                    file.type === "image/png" || file.type === "image/webp"
                        ? "image/jpeg" // still convert to jpeg to shrink
                        : "image/jpeg";
                try {
                    const dataUrl = canvas.toDataURL(mime, quality);
                    resolve(dataUrl);
                } catch (e) {
                    reject(e);
                }
            };
            img.src = reader.result;
        };
        reader.readAsDataURL(file);
    });
}
